<div class="w-full flex overflow-hidden">

  <app-dashboard-aside  (hoverChange)="updateHoverState($event)"
  ></app-dashboard-aside>

  <div
  [ngClass]="{'pl-[4.1%] w-[95.9%]': isHovered}" class="xl:ml-16 w-full h-screen overflow-scroll ">
    <app-dashboard-navbar />
    <app-dashboard-safe-zone class="relative">
      <ng-content></ng-content>
    </app-dashboard-safe-zone>

  </div>
</div>
